const useModelNames = () => (modelId) => modelId;
export default useModelNames;
